export default __webpack_public_path__ + "static/N0158-e84e612a767a080a46ef216e857b1931.png";